import { Container } from './container';

export function write(container: Container): Uint8Array {
    return new Uint8Array();
}
